import axios, { AxiosError } from "axios";
import Cookies from "js-cookie";
import { message } from "antd";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const api = axios.create({ baseURL: API_BASE_URL });

// Get token from cookie
const getToken = () => Cookies.get("userToken");

// Logout function
const handleLogout = () => {
  Cookies.remove("userToken");
  message.warning("Session expired. Please login again.");
  window.location.href = "/login"; // force redirect
};

// Request interceptor to attach token
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  return config;
});

// Response interceptor to catch 401 (token expired)
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) handleLogout();
    return Promise.reject(error);
  }
);

export default api;
